export default __webpack_public_path__ + "static/media/emoji-meh.7f1f62ab.svg";